(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('userSettingsService', userSettingsService);

    userSettingsService.$inject = ['$http'];

    function userSettingsService($http) {
        var baseUrl = '/user-settings/';

        return {
            setUnits: setUnits
        };
        
        function setUnits(unit, canceler) {
            var params = {
                Unit: unit
            };

            var promise = $http.post(baseUrl + "set-units", params, {
                    canceler: canceler
                })
                .then(function (response) {
                    return response.data;
                });

            return promise;
        }
    }
}());